import React from "react"
import {
  IoChevronBack,
  IoChevronForwardOutline,
  IoChevronDownOutline,
  IoChevronUpOutline,
  IoShareOutline,
  IoClose,
  IoArrowBack,
  IoArrowForward,
  IoAddOutline,
  IoMailOutline,
  IoWarningOutline,
  IoInformationCircleOutline,
  IoCheckmarkCircleOutline,
  IoTime,
  IoMenuOutline,
} from "react-icons/io5"
import { MdErrorOutline } from "react-icons/md"
import { IconBaseProps } from "react-icons/lib"
import { FaMapMarkerAlt } from "react-icons/fa"

export const WarningIcon = (props: IconBaseProps) => (
  <IoWarningOutline {...props} />
)
export const InformationIcon = (props: IconBaseProps) => (
  <IoInformationCircleOutline {...props} />
)
export const CheckmarkIcon = (props: IconBaseProps) => (
  <IoCheckmarkCircleOutline {...props} />
)
export const ErrorIcon = (props: IconBaseProps) => <MdErrorOutline {...props} />

export const MailIcon = (props: IconBaseProps) => <IoMailOutline {...props} />
export const BackArrowIcon = (props: IconBaseProps) => (
  <IoArrowBack {...props} />
)

export const ForwardArrowIcon = (props: IconBaseProps) => (
  <IoArrowForward {...props} />
)

export const ArrowBackIcon = (props: IconBaseProps) => (
  <IoChevronBack {...props} />
)

export const ArrowForwardIcon = (props: IconBaseProps) => (
  <IoChevronForwardOutline {...props} />
)

export const ArrowDownIcon = (props: IconBaseProps) => (
  <IoChevronDownOutline {...props} />
)

export const ArrowUpIcon = (props: IconBaseProps) => (
  <IoChevronUpOutline {...props} />
)

export const ShareIcon = (props: IconBaseProps) => <IoShareOutline {...props} />

export const MenuIcon = (props: IconBaseProps) => <IoMenuOutline {...props} />

export const CloseIcon = (props: IconBaseProps) => <IoClose {...props} />

export const PlusIcon = (props: IconBaseProps) => <IoAddOutline {...props} />

export const MarkerIcon = (props: IconBaseProps) => (
  <FaMapMarkerAlt {...props} />
)

export const ClockIcon = (props: IconBaseProps) => <IoTime {...props} />

export { CartIcon } from "./CartIcon"
export { EyeIcon } from "./EyeIcon"
export { TrashIcon } from "./TrashIcon"
export { SearchIcon } from "./SearchIcon"
export { BasketIcon } from "./BasketIcon"
export { HeartIconEmpty } from "./HeartIconEmpty"
export { HeartIconFilled } from "./HeartIconFilled"
export { AccountIcon } from "./AccountIcon"
export { CustomerServiceIcon } from "./CustomerServiceIcon"
export { GiftIcon } from "./GiftIcon"
export { ClickAndCollectIcon } from "./ClickAndCollect"
export { ShippingIcon } from "./ShippingIcon"
export { PackageIcon } from "./PackageIcon"
